import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    //next({ name: 'home' })
                    next({ name: 'map' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                next({ name: 'login' });
                // const authRequiredOnPreviousRoute = routeFrom.matched.some(
                //     (route) => route.push('/login')
                // )
                // // Navigate back to previous page, or home as a fallback
                // next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index')
        
    },
    {
        path: '/users',
        name: 'Users',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/users/userstable')
    },
    {
        path: '/consumers',
        name: 'Consumers',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/consumers/consumerstable')
    },
    {
        path: '/productions',
        name: 'Productions',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/admin/productions/productionstable')
    },
    {
        path: '/map',
        name: 'map',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/front/map-index-google')
    },
    {
        path: '/setting/types',
        name: 'types',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/admin/settings/companyTypesTable')
    }
]
